module.exports = __webpack_public_path__ + "static/media/Tetris.c25f2661.md";